import React from "react";
import workingForms15 from "../../assets/working-forms-1.5x.png";
import workingForms2 from "../../assets/working-forms-2x.png";
import workingForms3 from "../../assets/working-forms-3x.png";
import workingForms1 from "../../assets/working-forms-1x.png";
import { Card, CardContent, Typography, Box, Divider } from "@mui/material";
import { State } from "models/Geography";
import { FeedbackCheck } from "./FeedbackCheck";
import MuiMarkdown from "mui-markdown";

interface Props {
  state?: State;
}

export const NoStateForms = ({ state }: Props): JSX.Element => {
  return (
    <Card>
      <CardContent
        sx={{
          display: "flex",
          flex: 1,
          flexDirection: "column",
          mt: 3,
          alignItems: "center",
        }}
      >
        {state?.content.probateFallbackContent ? (
          <Box>
            <MuiMarkdown
              overrides={{
                p: {
                  component: "p",
                  props: {
                    style: { marginBottom: "0.5rem" },
                  },
                },
                li: {
                  component: "li",
                  props: {
                    style: { marginBottom: "0.5rem" },
                  },
                },
              }}
            >
              {state?.content.probateFallbackContent}
            </MuiMarkdown>
          </Box>
        ) : (
          <>
            <img
              srcSet={`${workingForms15} 1.5x, ${workingForms2} 2x, ${workingForms3} 3x`}
              src={workingForms1}
              alt="We're working on these forms"
              style={{ maxWidth: 477, width: "100%" }}
            />
            <Typography variant="h4" sx={{ my: 2, textAlign: "center" }}>
              We’re still working on preparing {state?.name} forms
            </Typography>
          </>
        )}
        <Divider sx={{ width: "100%", margin: "2rem" }} />
        <FeedbackCheck
          screenName="FormsLibrary-NoStateForms"
          questionText="Please send us a message and we'll help you locate the forms you’re looking for."
          buttonText="Message Atticus"
        />
      </CardContent>
    </Card>
  );
};
